// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CognitiveJourney-module__font-s-10___zdtgP {
  font-size: 10px !important;
}

.CognitiveJourney-module__font-s-12___WGSX3 {
  font-size: 12px !important;
}

.CognitiveJourney-module__font-s-13___Y9qoJ {
  font-size: 13px !important;
}

.CognitiveJourney-module__font-s-14___y2XSF {
  font-size: 14px !important;
}

.CognitiveJourney-module__font-s-15___MjMVe {
  font-size: 15px !important;
}

.CognitiveJourney-module__font-s-16____0dCJ {
  font-size: 16px !important;
}

.CognitiveJourney-module__font-s-18___xDnn2 {
  font-size: 18px !important;
}

.CognitiveJourney-module__font-s-20___GnBRO {
  font-size: 20px !important;
}

.CognitiveJourney-module__font-s-22___KgBN9 {
  font-size: 22px !important;
}

.CognitiveJourney-module__font-s-28___Yg9vL {
  font-size: 28px !important;
}

.CognitiveJourney-module__font-w-400___rkmas {
  font-weight: 400 !important;
}

.CognitiveJourney-module__font-w-500___VJrT7 {
  font-weight: 500 !important;
}

.CognitiveJourney-module__font-w-600___Bq1G1 {
  font-weight: 600 !important;
}

.CognitiveJourney-module__font-w-700___cWQeU {
  font-weight: 700 !important;
}

.CognitiveJourney-module__p-5___xz7iL {
  padding: 5px !important;
}

.CognitiveJourney-module__p-12___NL9D4 {
  padding: 12px !important;
}

.CognitiveJourney-module__p-16___lK7cC {
  padding: 16px !important;
}

.CognitiveJourney-module__p-30___zqyBB {
  padding: 30px !important;
}

.CognitiveJourney-module__p-b-0___xEDs6 {
  padding-bottom: 0 !important;
}

.CognitiveJourney-module__p-b-5___ABO6i {
  padding-bottom: 5px !important;
}

.CognitiveJourney-module__p-b-10___HSDvk {
  padding-bottom: 10px !important;
}

.CognitiveJourney-module__p-b-12___XKNYk {
  padding-bottom: 12px !important;
}

.CognitiveJourney-module__p-b-16___ldyo2 {
  padding-bottom: 16px !important;
}

.CognitiveJourney-module__p-b-18___rzoti {
  padding-bottom: 18px !important;
}

.CognitiveJourney-module__p-b-20___EXcO0 {
  padding-bottom: 20px !important;
}

.CognitiveJourney-module__p-b-25___awxVB {
  padding-bottom: 25px !important;
}

.CognitiveJourney-module__p-b-30___HGnuV {
  padding-bottom: 30px !important;
}

.CognitiveJourney-module__p-b-50___wPiok {
  padding-bottom: 50px !important;
}

.CognitiveJourney-module__p-t-0___PcKdv {
  padding-top: 0 !important;
}

.CognitiveJourney-module__p-t-12___Jx9eM {
  padding-top: 12px !important;
}

.CognitiveJourney-module__p-t-16___ga1uC {
  padding-top: 16px !important;
}

.CognitiveJourney-module__p-t-18___ZK_pN {
  padding-top: 18px !important;
}

.CognitiveJourney-module__p-t-20___LjCXl {
  padding-top: 20px !important;
}

.CognitiveJourney-module__p-t-30___CU1VU {
  padding-top: 30px !important;
}

.CognitiveJourney-module__p-t-40___zoaiH {
  padding-top: 40px !important;
}

.CognitiveJourney-module__p-t-50___dQ6TD {
  padding-top: 50px !important;
}

.CognitiveJourney-module__p-l-20___Ecmn1 {
  padding-left: 20px !important;
}

.CognitiveJourney-module__p-l-30___lHqM5 {
  padding-left: 30px !important;
}

.CognitiveJourney-module__p-l-40___xzQVJ {
  padding-left: 40px !important;
}

.CognitiveJourney-module__p-r-16___rPUBS {
  padding-right: 16px !important;
}

.CognitiveJourney-module__p-r-20___W7ZEj {
  padding-right: 20px !important;
}

.CognitiveJourney-module__p-r-30___shibb {
  padding-right: 30px !important;
}

.CognitiveJourney-module__p-r-50___fBRoe {
  padding-right: 50px !important;
}

.CognitiveJourney-module__p-r-60____M2BR {
  padding-right: 60px !important;
}

.CognitiveJourney-module__m-b-1___OU21W {
  margin-bottom: 1px !important;
}

.CognitiveJourney-module__m-b-2___Me1YF {
  margin-bottom: 2px !important;
}

.CognitiveJourney-module__m-b-6___ZQK8i {
  margin-bottom: 6px !important;
}

.CognitiveJourney-module__m-b-8___QEmra {
  margin-bottom: 8px !important;
}

.CognitiveJourney-module__m-b-10____j1Dm {
  margin-bottom: 10px !important;
}

.CognitiveJourney-module__m-b-14___A0tNB {
  margin-bottom: 14px !important;
}

.CognitiveJourney-module__m-b-16___iobGg {
  margin-bottom: 16px !important;
}

.CognitiveJourney-module__m-b-20___b16Rx {
  margin-bottom: 20px !important;
}

.CognitiveJourney-module__m-b-22___Aei3F {
  margin-bottom: 22px !important;
}

.CognitiveJourney-module__m-b-24___KU24G {
  margin-bottom: 24px !important;
}

.CognitiveJourney-module__m-b-30___LDApq {
  margin-bottom: 30px !important;
}

.CognitiveJourney-module__m-b-32___rciTE {
  margin-bottom: 32px !important;
}

.CognitiveJourney-module__m-b-40___rgKF9 {
  margin-bottom: 40px !important;
}

.CognitiveJourney-module__m-t-2___BShLK {
  margin-top: 2px !important;
}

.CognitiveJourney-module__m-t-3___cIxZe {
  margin-top: 3px !important;
}

.CognitiveJourney-module__m-t-4___tsIaP {
  margin-top: 4px !important;
}

.CognitiveJourney-module__m-t-5___ECCg8 {
  margin-top: 5px !important;
}

.CognitiveJourney-module__m-t-8___SGBL4 {
  margin-top: 8px !important;
}

.CognitiveJourney-module__m-t-10___cpcvX {
  margin-top: 10px !important;
}

.CognitiveJourney-module__m-t-15___vfDt1 {
  margin-top: 15px !important;
}

.CognitiveJourney-module__m-t-16___PUScu {
  margin-top: 16px !important;
}

.CognitiveJourney-module__m-t-20___tQdVU {
  margin-top: 20px !important;
}

.CognitiveJourney-module__m-t-22___NfVJt {
  margin-top: 22px !important;
}

.CognitiveJourney-module__m-t-30___UKwuE {
  margin-top: 30px !important;
}

.CognitiveJourney-module__m-t-32___r6qx4 {
  margin-top: 32px !important;
}

.CognitiveJourney-module__m-l-auto___TJk_x {
  margin-left: auto !important;
}

.CognitiveJourney-module__m-l-4___ZSGgH {
  margin-left: 4px !important;
}

.CognitiveJourney-module__m-l-5___Vt78W {
  margin-left: 5px !important;
}

.CognitiveJourney-module__m-l-6___NzmzI {
  margin-left: 6px !important;
}

.CognitiveJourney-module__m-l-8___vY_pb {
  margin-left: 8px !important;
}

.CognitiveJourney-module__m-l-10___cRcJw {
  margin-left: 10px !important;
}

.CognitiveJourney-module__m-l-16____RQ0t {
  margin-left: 16px !important;
}

.CognitiveJourney-module__m-l-20___qK9Jm {
  margin-left: 20px !important;
}

.CognitiveJourney-module__m-l-24___RWpZn {
  margin-left: 24px !important;
}

.CognitiveJourney-module__m-l-30___o_bMX {
  margin-left: 30px !important;
}

.CognitiveJourney-module__m-l-35___wm5Fl {
  margin-left: 35px !important;
}

.CognitiveJourney-module__m-l-40___Q0dZJ {
  margin-left: 40px !important;
}

.CognitiveJourney-module__m-r-8___R0YOB {
  margin-right: 8px !important;
}

.CognitiveJourney-module__m-r-10___y6XqS {
  margin-right: 10px !important;
}

.CognitiveJourney-module__m-r-16___bI8Wi {
  margin-right: 16px !important;
}

.CognitiveJourney-module__m-r-20___vBTtR {
  margin-right: 20px !important;
}

.CognitiveJourney-module__m-r-24___OOdcP {
  margin-right: 24px !important;
}

.CognitiveJourney-module__m-r-30___ilWQu {
  margin-right: 30px !important;
}

.CognitiveJourney-module__m-r-40___M0EmF {
  margin-right: 40px !important;
}

.CognitiveJourney-module__border-r-3___MaXt2 {
  border-radius: 3px !important;
}

.CognitiveJourney-module__border-r-4___UAHMC {
  border-radius: 4px !important;
}

.CognitiveJourney-module__border-r-6___rWMYu {
  border-radius: 6px !important;
}

.CognitiveJourney-module__border-r-10___avPJR {
  border-radius: 10px !important;
}

.CognitiveJourney-module__border-r-12___glEKl {
  border-radius: 12px !important;
}

.CognitiveJourney-module__border-r-16___nFvAQ {
  border-radius: 16px !important;
}

.CognitiveJourney-module__border-r-50___VaGzJ {
  border-radius: 50% !important;
}

.CognitiveJourney-module__primary-border___ABViX {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveJourney-module__primary-border-b___R6pej {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveJourney-module__primary-border-t___Ugrzh {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveJourney-module__primary-border-l___Q3CL4 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveJourney-module__primary-border-r____Zyp_ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveJourney-module__secondary-border___xpSN2 {
  border: 1px solid #637768;
}

.CognitiveJourney-module__secondary-border-b___Wlpbw {
  border-bottom: 1px solid #637768;
}

.CognitiveJourney-module__secondary-border-t___DIx2C {
  border-top: 1px solid #637768;
}

.CognitiveJourney-module__secondary-border-l___nTule {
  border-left: 1px solid #637768;
}

.CognitiveJourney-module__secondary-border-r___eM38g {
  border-right: 1px solid #637768;
}

.CognitiveJourney-module__gap-0___mNzEq {
  gap: 0 !important;
}

.CognitiveJourney-module__gap-2___nbzJp {
  gap: 2px !important;
}

.CognitiveJourney-module__gap-4___obGXw {
  gap: 4px !important;
}

.CognitiveJourney-module__gap-5___pVbSG {
  gap: 5px !important;
}

.CognitiveJourney-module__gap-6____EdMy {
  gap: 6px !important;
}

.CognitiveJourney-module__gap-8___PIRvl {
  gap: 8px !important;
}

.CognitiveJourney-module__gap-10___VdPCY {
  gap: 10px !important;
}

.CognitiveJourney-module__gap-12___NjvTv {
  gap: 12px !important;
}

.CognitiveJourney-module__gap-14___u5wNI {
  gap: 14px !important;
}

.CognitiveJourney-module__gap-16___IJtbm {
  gap: 16px !important;
}

.CognitiveJourney-module__gap-18___bYlEf {
  gap: 18px !important;
}

.CognitiveJourney-module__gap-20___El4xK {
  gap: 20px !important;
}

.CognitiveJourney-module__gap-24___kDJPk {
  gap: 24px !important;
}

.CognitiveJourney-module__gap-26___OlciU {
  gap: 26px !important;
}

.CognitiveJourney-module__gap-30___xEu4N {
  gap: 30px !important;
}

.CognitiveJourney-module__gap-32___bvVCM {
  gap: 32px !important;
}

.CognitiveJourney-module__gap-40___gL8DX {
  gap: 40px !important;
}

.CognitiveJourney-module__gap-50___mTOln {
  gap: 50px !important;
}

.CognitiveJourney-module__flex-1___bZns1 {
  flex: 1;
}

.CognitiveJourney-module__flex-none___S_Wdc {
  flex: none !important;
}

.CognitiveJourney-module__flex-column___d6jU0 {
  display: flex;
  flex-direction: column !important;
}

.CognitiveJourney-module__flex-row___xEXwa {
  display: flex;
  flex-direction: row !important;
}

.CognitiveJourney-module__vertically-centered___OfK7q {
  display: flex;
  align-items: center !important;
}

.CognitiveJourney-module__horizontally-centered___JB0VQ {
  display: flex;
  justify-content: center !important;
}

.CognitiveJourney-module__horizontally-end___iGUiA {
  display: flex;
  justify-content: end !important;
}

.CognitiveJourney-module__vertically-start___xdHRh {
  display: flex;
  align-items: start !important;
}

.CognitiveJourney-module__space-between___CdZKD {
  display: flex;
  justify-content: space-between !important;
}

.CognitiveJourney-module__flex-wrap___iO50q {
  flex-wrap: wrap !important;
}

.CognitiveJourney-module__height-100___ZqCe8 {
  height: 100%;
}

.CognitiveJourney-module__width-50___gaPcM {
  width: 50% !important;
}

.CognitiveJourney-module__width-100___iSLGe {
  width: 100%;
}

.CognitiveJourney-module__cursor-pointer___kR1mo {
  cursor: pointer;
}

.CognitiveJourney-module__cursor-not-allowed___ukAee {
  cursor: not-allowed !important;
}

.CognitiveJourney-module__absolute-centered___cejSu {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CognitiveJourney-module__absolute___t63Ze {
  position: absolute;
}

.CognitiveJourney-module__relative___LXQrZ {
  position: relative;
}

.CognitiveJourney-module__fixed___ErW2O {
  position: fixed;
}

.CognitiveJourney-module__visible___cJxo4 {
  opacity: 1;
}

.CognitiveJourney-module__invisible___sNg4S {
  opacity: 0;
}

.CognitiveJourney-module__col-90___fGrEW {
  width: 90% !important;
}

.CognitiveJourney-module__col-auto___EAtvO {
  width: auto !important;
}

.CognitiveJourney-module__medical-tabs___JRoFY {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CognitiveJourney-module__medical-table-new___Jlo9o {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CognitiveJourney-module__medical-table-new___Jlo9o:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CognitiveJourney-module__medical-table-new___Jlo9o::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CognitiveJourney-module__medical-table-new___Jlo9o::-webkit-scrollbar-track {
  display: none;
}
.CognitiveJourney-module__medical-table-new___Jlo9o.CognitiveJourney-module__no-pagination___Fq0uQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CognitiveJourney-module__medical-table-new___Jlo9o.CognitiveJourney-module__no-pagination___Fq0uQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CognitiveJourney-module__medical-table-new___Jlo9o.CognitiveJourney-module__no-pagination___Fq0uQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CognitiveJourney-module__medical-table-new___Jlo9o.CognitiveJourney-module__no-pagination___Fq0uQ::-webkit-scrollbar-track {
  display: none;
}

.CognitiveJourney-module__medical-table-empty___ccJbe {
  padding: 14px 40px !important;
}

.CognitiveJourney-module__icon-btn___jaB_q {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CognitiveJourney-module__search-icon___RjYMx {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CognitiveJourney-module__disable-select___jjjAl {
  user-select: none;
}

.CognitiveJourney-module__break-word___vFHJP {
  word-break: break-word;
}

.CognitiveJourney-module__popup-clear-btn___mLZz9 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CognitiveJourney-module__scroll-m-b-20___LpFJv {
  scroll-margin-bottom: 20px;
}

.CognitiveJourney-module__title___qCv8y {
  color: #375844;
}

.CognitiveJourney-module__icon___GptZk {
  width: 16px;
  height: 16px;
  filter: invert(66%) sepia(54%) saturate(101%) hue-rotate(80deg) brightness(81%) contrast(81%);
}

.CognitiveJourney-module__checkbox___oIzhK {
  min-width: 150px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Cognitive/CognitiveJourney/CognitiveJourney.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,6FAAA;AA8pBF;;AA3pBA;EACE,gBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.title {\n  color: get-color(greenNew, dark);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  filter: invert(66%) sepia(54%) saturate(101%) hue-rotate(80deg) brightness(81%) contrast(81%);\n}\n\n.checkbox {\n  min-width: 150px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CognitiveJourney-module__font-s-10___zdtgP`,
	"fontS12": `CognitiveJourney-module__font-s-12___WGSX3`,
	"fontS13": `CognitiveJourney-module__font-s-13___Y9qoJ`,
	"fontS14": `CognitiveJourney-module__font-s-14___y2XSF`,
	"fontS15": `CognitiveJourney-module__font-s-15___MjMVe`,
	"fontS16": `CognitiveJourney-module__font-s-16____0dCJ`,
	"fontS18": `CognitiveJourney-module__font-s-18___xDnn2`,
	"fontS20": `CognitiveJourney-module__font-s-20___GnBRO`,
	"fontS22": `CognitiveJourney-module__font-s-22___KgBN9`,
	"fontS28": `CognitiveJourney-module__font-s-28___Yg9vL`,
	"fontW400": `CognitiveJourney-module__font-w-400___rkmas`,
	"fontW500": `CognitiveJourney-module__font-w-500___VJrT7`,
	"fontW600": `CognitiveJourney-module__font-w-600___Bq1G1`,
	"fontW700": `CognitiveJourney-module__font-w-700___cWQeU`,
	"p5": `CognitiveJourney-module__p-5___xz7iL`,
	"p12": `CognitiveJourney-module__p-12___NL9D4`,
	"p16": `CognitiveJourney-module__p-16___lK7cC`,
	"p30": `CognitiveJourney-module__p-30___zqyBB`,
	"pB0": `CognitiveJourney-module__p-b-0___xEDs6`,
	"pB5": `CognitiveJourney-module__p-b-5___ABO6i`,
	"pB10": `CognitiveJourney-module__p-b-10___HSDvk`,
	"pB12": `CognitiveJourney-module__p-b-12___XKNYk`,
	"pB16": `CognitiveJourney-module__p-b-16___ldyo2`,
	"pB18": `CognitiveJourney-module__p-b-18___rzoti`,
	"pB20": `CognitiveJourney-module__p-b-20___EXcO0`,
	"pB25": `CognitiveJourney-module__p-b-25___awxVB`,
	"pB30": `CognitiveJourney-module__p-b-30___HGnuV`,
	"pB50": `CognitiveJourney-module__p-b-50___wPiok`,
	"pT0": `CognitiveJourney-module__p-t-0___PcKdv`,
	"pT12": `CognitiveJourney-module__p-t-12___Jx9eM`,
	"pT16": `CognitiveJourney-module__p-t-16___ga1uC`,
	"pT18": `CognitiveJourney-module__p-t-18___ZK_pN`,
	"pT20": `CognitiveJourney-module__p-t-20___LjCXl`,
	"pT30": `CognitiveJourney-module__p-t-30___CU1VU`,
	"pT40": `CognitiveJourney-module__p-t-40___zoaiH`,
	"pT50": `CognitiveJourney-module__p-t-50___dQ6TD`,
	"pL20": `CognitiveJourney-module__p-l-20___Ecmn1`,
	"pL30": `CognitiveJourney-module__p-l-30___lHqM5`,
	"pL40": `CognitiveJourney-module__p-l-40___xzQVJ`,
	"pR16": `CognitiveJourney-module__p-r-16___rPUBS`,
	"pR20": `CognitiveJourney-module__p-r-20___W7ZEj`,
	"pR30": `CognitiveJourney-module__p-r-30___shibb`,
	"pR50": `CognitiveJourney-module__p-r-50___fBRoe`,
	"pR60": `CognitiveJourney-module__p-r-60____M2BR`,
	"mB1": `CognitiveJourney-module__m-b-1___OU21W`,
	"mB2": `CognitiveJourney-module__m-b-2___Me1YF`,
	"mB6": `CognitiveJourney-module__m-b-6___ZQK8i`,
	"mB8": `CognitiveJourney-module__m-b-8___QEmra`,
	"mB10": `CognitiveJourney-module__m-b-10____j1Dm`,
	"mB14": `CognitiveJourney-module__m-b-14___A0tNB`,
	"mB16": `CognitiveJourney-module__m-b-16___iobGg`,
	"mB20": `CognitiveJourney-module__m-b-20___b16Rx`,
	"mB22": `CognitiveJourney-module__m-b-22___Aei3F`,
	"mB24": `CognitiveJourney-module__m-b-24___KU24G`,
	"mB30": `CognitiveJourney-module__m-b-30___LDApq`,
	"mB32": `CognitiveJourney-module__m-b-32___rciTE`,
	"mB40": `CognitiveJourney-module__m-b-40___rgKF9`,
	"mT2": `CognitiveJourney-module__m-t-2___BShLK`,
	"mT3": `CognitiveJourney-module__m-t-3___cIxZe`,
	"mT4": `CognitiveJourney-module__m-t-4___tsIaP`,
	"mT5": `CognitiveJourney-module__m-t-5___ECCg8`,
	"mT8": `CognitiveJourney-module__m-t-8___SGBL4`,
	"mT10": `CognitiveJourney-module__m-t-10___cpcvX`,
	"mT15": `CognitiveJourney-module__m-t-15___vfDt1`,
	"mT16": `CognitiveJourney-module__m-t-16___PUScu`,
	"mT20": `CognitiveJourney-module__m-t-20___tQdVU`,
	"mT22": `CognitiveJourney-module__m-t-22___NfVJt`,
	"mT30": `CognitiveJourney-module__m-t-30___UKwuE`,
	"mT32": `CognitiveJourney-module__m-t-32___r6qx4`,
	"mLAuto": `CognitiveJourney-module__m-l-auto___TJk_x`,
	"mL4": `CognitiveJourney-module__m-l-4___ZSGgH`,
	"mL5": `CognitiveJourney-module__m-l-5___Vt78W`,
	"mL6": `CognitiveJourney-module__m-l-6___NzmzI`,
	"mL8": `CognitiveJourney-module__m-l-8___vY_pb`,
	"mL10": `CognitiveJourney-module__m-l-10___cRcJw`,
	"mL16": `CognitiveJourney-module__m-l-16____RQ0t`,
	"mL20": `CognitiveJourney-module__m-l-20___qK9Jm`,
	"mL24": `CognitiveJourney-module__m-l-24___RWpZn`,
	"mL30": `CognitiveJourney-module__m-l-30___o_bMX`,
	"mL35": `CognitiveJourney-module__m-l-35___wm5Fl`,
	"mL40": `CognitiveJourney-module__m-l-40___Q0dZJ`,
	"mR8": `CognitiveJourney-module__m-r-8___R0YOB`,
	"mR10": `CognitiveJourney-module__m-r-10___y6XqS`,
	"mR16": `CognitiveJourney-module__m-r-16___bI8Wi`,
	"mR20": `CognitiveJourney-module__m-r-20___vBTtR`,
	"mR24": `CognitiveJourney-module__m-r-24___OOdcP`,
	"mR30": `CognitiveJourney-module__m-r-30___ilWQu`,
	"mR40": `CognitiveJourney-module__m-r-40___M0EmF`,
	"borderR3": `CognitiveJourney-module__border-r-3___MaXt2`,
	"borderR4": `CognitiveJourney-module__border-r-4___UAHMC`,
	"borderR6": `CognitiveJourney-module__border-r-6___rWMYu`,
	"borderR10": `CognitiveJourney-module__border-r-10___avPJR`,
	"borderR12": `CognitiveJourney-module__border-r-12___glEKl`,
	"borderR16": `CognitiveJourney-module__border-r-16___nFvAQ`,
	"borderR50": `CognitiveJourney-module__border-r-50___VaGzJ`,
	"primaryBorder": `CognitiveJourney-module__primary-border___ABViX`,
	"primaryBorderB": `CognitiveJourney-module__primary-border-b___R6pej`,
	"primaryBorderT": `CognitiveJourney-module__primary-border-t___Ugrzh`,
	"primaryBorderL": `CognitiveJourney-module__primary-border-l___Q3CL4`,
	"primaryBorderR": `CognitiveJourney-module__primary-border-r____Zyp_`,
	"secondaryBorder": `CognitiveJourney-module__secondary-border___xpSN2`,
	"secondaryBorderB": `CognitiveJourney-module__secondary-border-b___Wlpbw`,
	"secondaryBorderT": `CognitiveJourney-module__secondary-border-t___DIx2C`,
	"secondaryBorderL": `CognitiveJourney-module__secondary-border-l___nTule`,
	"secondaryBorderR": `CognitiveJourney-module__secondary-border-r___eM38g`,
	"gap0": `CognitiveJourney-module__gap-0___mNzEq`,
	"gap2": `CognitiveJourney-module__gap-2___nbzJp`,
	"gap4": `CognitiveJourney-module__gap-4___obGXw`,
	"gap5": `CognitiveJourney-module__gap-5___pVbSG`,
	"gap6": `CognitiveJourney-module__gap-6____EdMy`,
	"gap8": `CognitiveJourney-module__gap-8___PIRvl`,
	"gap10": `CognitiveJourney-module__gap-10___VdPCY`,
	"gap12": `CognitiveJourney-module__gap-12___NjvTv`,
	"gap14": `CognitiveJourney-module__gap-14___u5wNI`,
	"gap16": `CognitiveJourney-module__gap-16___IJtbm`,
	"gap18": `CognitiveJourney-module__gap-18___bYlEf`,
	"gap20": `CognitiveJourney-module__gap-20___El4xK`,
	"gap24": `CognitiveJourney-module__gap-24___kDJPk`,
	"gap26": `CognitiveJourney-module__gap-26___OlciU`,
	"gap30": `CognitiveJourney-module__gap-30___xEu4N`,
	"gap32": `CognitiveJourney-module__gap-32___bvVCM`,
	"gap40": `CognitiveJourney-module__gap-40___gL8DX`,
	"gap50": `CognitiveJourney-module__gap-50___mTOln`,
	"flex1": `CognitiveJourney-module__flex-1___bZns1`,
	"flexNone": `CognitiveJourney-module__flex-none___S_Wdc`,
	"flexColumn": `CognitiveJourney-module__flex-column___d6jU0`,
	"flexRow": `CognitiveJourney-module__flex-row___xEXwa`,
	"verticallyCentered": `CognitiveJourney-module__vertically-centered___OfK7q`,
	"horizontallyCentered": `CognitiveJourney-module__horizontally-centered___JB0VQ`,
	"horizontallyEnd": `CognitiveJourney-module__horizontally-end___iGUiA`,
	"verticallyStart": `CognitiveJourney-module__vertically-start___xdHRh`,
	"spaceBetween": `CognitiveJourney-module__space-between___CdZKD`,
	"flexWrap": `CognitiveJourney-module__flex-wrap___iO50q`,
	"height100": `CognitiveJourney-module__height-100___ZqCe8`,
	"width50": `CognitiveJourney-module__width-50___gaPcM`,
	"width100": `CognitiveJourney-module__width-100___iSLGe`,
	"cursorPointer": `CognitiveJourney-module__cursor-pointer___kR1mo`,
	"cursorNotAllowed": `CognitiveJourney-module__cursor-not-allowed___ukAee`,
	"absoluteCentered": `CognitiveJourney-module__absolute-centered___cejSu`,
	"absolute": `CognitiveJourney-module__absolute___t63Ze`,
	"relative": `CognitiveJourney-module__relative___LXQrZ`,
	"fixed": `CognitiveJourney-module__fixed___ErW2O`,
	"visible": `CognitiveJourney-module__visible___cJxo4`,
	"invisible": `CognitiveJourney-module__invisible___sNg4S`,
	"col90": `CognitiveJourney-module__col-90___fGrEW`,
	"colAuto": `CognitiveJourney-module__col-auto___EAtvO`,
	"medicalTabs": `CognitiveJourney-module__medical-tabs___JRoFY`,
	"medicalTableNew": `CognitiveJourney-module__medical-table-new___Jlo9o`,
	"noPagination": `CognitiveJourney-module__no-pagination___Fq0uQ`,
	"medicalTableEmpty": `CognitiveJourney-module__medical-table-empty___ccJbe`,
	"iconBtn": `CognitiveJourney-module__icon-btn___jaB_q`,
	"searchIcon": `CognitiveJourney-module__search-icon___RjYMx`,
	"disableSelect": `CognitiveJourney-module__disable-select___jjjAl`,
	"breakWord": `CognitiveJourney-module__break-word___vFHJP`,
	"popupClearBtn": `CognitiveJourney-module__popup-clear-btn___mLZz9`,
	"scrollMB20": `CognitiveJourney-module__scroll-m-b-20___LpFJv`,
	"title": `CognitiveJourney-module__title___qCv8y`,
	"icon": `CognitiveJourney-module__icon___GptZk`,
	"checkbox": `CognitiveJourney-module__checkbox___oIzhK`
};
module.exports = ___CSS_LOADER_EXPORT___;
